import { render, staticRenderFns } from "./Moderation.vue?vue&type=template&id=d8691740&"
import script from "./Moderation.vue?vue&type=script&lang=ts&"
export * from "./Moderation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports